import { DescriptionText, FlexContainer, H1Text, H2Text, Hr } from "../../../../design";
import React from "react";
import { Col, Row } from "react-awesome-styled-grid";
import { REFRENCE_ID_LENGTH } from "../../../../appconstants";
import { AmountDivideByHundred } from "../../../../helper";
import SmallScreenHeader from "../../../../components/smallscreen/header";
import currencyFormatter from "../../../../utils/currencyformatter";

type Props = {
  payment: Object,
  tabName: String,
  bankImageUrl: String,
  cancelUrlLink: String,
}

const Header = (props: Props) => {
  const { payment, tabName, bankImageUrl, cancelUrlLink } = props;
  const largeLogo = (payment && payment.account && payment.account.largeLogo) ? payment.account.largeLogo : null;
  
  const customContainerProps = {
    // borderWidth: '5px !important',
    // borderColor: '#000 !important',
    // borderStyle: 'solid !important',
    borderRadius: '10px !important',
    width: '100%',
    padding: '5% !important',
    backgroundColor: '#fff',
  };

  const customFlexContainerProps = {
    width: '100%',
  }

  const customPrimaryHeadingProps = {
    fontWeight: 'bold',
    marginTop: '5px',
    marginBottom: '5px',
    fontSize: '20px',
  };

  const customSecondaryHeadingProps = {
    fontWeight: 'bold',
    textTransform: 'none',
    marginRight: '10px',
  }

  const customDescriptionProps = {
    fontSize: '18px',
    whiteSpace: 'wrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };
  
  return (
    <SmallScreenHeader 
      paymentCheckout={true} 
      bankImageUrl={bankImageUrl} 
      largeLogo={largeLogo}
      cancelUrlLink={cancelUrlLink}
    >
      <FlexContainer {...customContainerProps}>
        <H1Text {...customPrimaryHeadingProps}>
          Payment Checkout
        </H1Text>
        <Hr/>
        <FlexContainer {...customFlexContainerProps}>
          <H2Text {...customSecondaryHeadingProps}>
            Payment For
          </H2Text>
          <DescriptionText {...customDescriptionProps}>
            {(payment && payment.description) || (payment && payment.account && payment.account.name)}
          </DescriptionText>
        </FlexContainer>
        <FlexContainer {...customFlexContainerProps}>
          <H2Text {...customSecondaryHeadingProps}>
            Reference Id:
          </H2Text>
          <DescriptionText {...customDescriptionProps}>
            {
              (payment && payment.gid) ? (payment.gid).slice(-REFRENCE_ID_LENGTH) : <>&#8211;</>
            }
          </DescriptionText>
        </FlexContainer>
        {
          tabName === 'UPI' && (
            <FlexContainer {...customFlexContainerProps}>
              <H2Text>
                Amount
              </H2Text>
              <DescriptionText>
                {payment ? `${currencyFormatter(AmountDivideByHundred(payment.inventoryOrder.total), payment.account.currency && payment.account.currency.name)}` : null}
              </DescriptionText>
            </FlexContainer>
          )
        }
      </FlexContainer>
    </SmallScreenHeader>
  )
};

export default Header;
